import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { AppSettings } from '../../app.settings';
import { EDIStatus } from "../models/edi-status.model";
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";

@Injectable()
export class EDIStatusService extends BaseService {

    constructor(private http: HttpClient,
        private config: AppSettings,) {
        super();
    }

    
    getEDIStatusList(supplierCode: string) : Observable<Array<EDIStatus>>{
        return this.http.get<Array<EDIStatus>>(`${this.config.BaseUrl}Profile/EDIStatus/GetEDIStatus/${supplierCode}`, { headers: this.setHeaders() })
        .pipe(map( res => {
            return res ? res : null
        }));        
    }
}


